$(function(){
//Overrides
  $(window).on('resize', function(){
    var newSlideHeight = $('.slideshowOuter.shopify-section .slideshow.slick-slider img.slide-image-size').height();
    //console.log(newSlideHeight);
    $('.slideshowOuter.shopify-section .slideshow.slick-slider').attr('style','height:'+newSlideHeight+'px!important');
  });
  $(window).on('load', function(){
    var newSlideHeight = $('.slideshowOuter.shopify-section .slideshow.slick-slider img.slide-image-size').height();
    //console.log(newSlideHeight);
  
  	$('.slideshowOuter.shopify-section .slideshow.slick-slider').animate({

      height: newSlideHeight+'px'
    }, 500, function() {
      // Animation complete.
    });
  });
});